import React, { Fragment } from "react";
import { Typography, Stack, Box } from "@mui/material";
import { InputField } from "./input";
import { CustomSelectField } from "./customSelect";
import { statesList } from "../createEditProfile/formFragments/constants";

export default function ContactInfo() {
  return (
    <Fragment key="contact info">
      <Typography
        variant="h4"
        sx={{
          color: "var(--Base-1000, #000)",
          fontFamily: "CircularStdBlack",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 900,
          lineHeight: "132%",
        }}
      >
        Contact Info
      </Typography>
      <hr style={{ color: "var(--border)", marginTop: "16px" }} />

      {/* Ensure equal spacing for all input fields */}
      <Stack spacing={3} mt={2} width={1} mb={3}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={3} width={1}>
          <Box flex={1} width="100%">
            <InputField
              type="tel"
              name="phoneNumber"
              label="Phone Number"
              placeholder="1234567890"
            />
          </Box>
          <Box flex={1} width="100%" sx={{ marginTop: "5px !important" }}>
            <InputField
              name="website"
              label="Personal Website"
              placeholder="https://www.personalwebsite.com"
              required={false}
            />
          </Box>
        </Stack>

        <InputField name="address1" label="Address Line 1" required placeholder="Address Line 1"/>
        <InputField name="address2" label="Address Line 2" required={false} placeholder="Address Line 2"/>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={3} width={1}>
          <InputField name="city" label="City" placeholder="New York City" />
          <CustomSelectField
            name="state"
            label="State"
            placeholder="New York"
            options={statesList}
          />
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          width={1 / 2}
        >
          <InputField name="zipcode" label="Zip Code" placeholder="10001" />
        </Stack>
      </Stack>
    </Fragment>
  );
}
